<template>
  <v-data-table
    :headers="sharkCarHeaders"
    :items="roundsData"
    :footer-props="{
      'items-per-page-options': [50, 100, 150],
    }"
    :loading="_roundsTableLoading"
    :server-items-length="total"
    :options.sync="options"
    @update:options="_getReportInstances(options)"
    class="elevation-1"
  >
    <template
      v-slot:item.course_launch_intent_mode="{ item }"
    >
      {{ formatLaunchMode(item.course_launch_intent_mode) }}
    </template>
    <template
      v-slot:item.start_time="{ item }"
    >
      {{ formatDate(item.start_time) }}
    </template>
    <template
      v-slot:item.end_time="{ item }"
    >
      {{ formatDate(item.end_time) }}
    </template>
    <template
        v-slot:item.group_name="{ item }"
      >
        <div class="text-capitalize">
          {{ item.group_name }}
        </div>
      </template>
  </v-data-table>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import FormatDate from '@/mixins/FormatDate';
import FormatLaunchMode from '@/mixins/FormatLaunchMode';
import { MobileView } from '@/mixins';
import Options from '@/mixins/Options';

export default {
  props: ['roundsData'],
  components: {},
  mixins: [MobileView, FormatDate, Options, FormatLaunchMode],
  data: () => ({
    sharkCarHeaders: [
      { text: 'Round ID', value: 'uuid' },
      { text: 'Course Name', value: 'group_name' },
      { text: 'Launch Mode', value: 'course_launch_intent_mode' },
      { text: 'Holes Played', value: 'holes_completed' },
      { text: 'Shark Car ID', value: 'gpsi_car_id' },
      { text: 'GPSi Car #', value: 'gpsi_car_number' },
      { text: 'MDN', value: 'mdn' },
      { text: 'Round Start', value: 'start_time' },
      { text: 'Round End', value: 'end_time' },
    ],
  }),
  computed: {
    ...mapGetters({
      _getQueryParams: 'reports/getQueryParams',
      _roundsTableLoading: 'reports/getRoundsTableLoading',
      currentClient: 'account/getCurrentClient',
    }),
    total() {
      return this.roundsData[0] ? parseInt(this.roundsData[0].total) : 0;
    },
    queryParams: {
      get() {
        return this._getQueryParams;
      },
      set(val) {
        this._setQueryParams(val);
      },
    },
  },
  methods: {
    ...mapMutations({
      _setQueryParams: 'reports/setQueryParams',
    }),
    ...mapActions({
      _getReportInstances: 'reports/acquireSessions',
    }),
    getGroupName(id) {
      let screenGroup = null;
      this.currentClient.groups.map((group) => {
        if (group.uuid === id) {
          screenGroup = group;
        }
      });
      if (screenGroup) {
        return screenGroup.group_name
          .toLowerCase()
          .split(' ')
          .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
          .join(' ');
      }
      return id;
    },
  },
};
</script>
